import React, {
  useReducer,
  useContext,
  useEffect,
  useRef,
  useMemo,
} from "react";
import { withRouter } from "react-router-dom";
import Tool_tabs from "../../Components/Tools/Tool_tabs";
import cls from "classnames";
import { CusButton } from "../../Components/From/Button";
import { CusInput } from "../../Components/From/Input";
import { FormattedMessage } from "react-intl";
import { Global } from "../../App";
import { AsyncModel, AsyncModelClose } from "../AsyncModel/AsyncModel";
import ReactLoading from "react-loading";
import PerfectScrollbar from "react-perfect-scrollbar";
import QrReader from "react-qr-reader";
import moment from "moment";
import {
  isIOS,
  isAndroid,
  isSafari,
  isChrome,
  isFirefox,
} from "react-device-detect";
import qs from "querystring";
// switch lang
import {
  langStringToCode,
  langCodeToString,
} from "../../Share/Tools/switchLang";
// api
import { getAllStore } from "../../Api/GetStore";
import {
  postManualVerifyQueue,
  postQRCodeVerifyQueue,
} from "../../Api/VerifyQueue";
import Tool_storeName from "../Tools/Tool_storeName";

const reducer = (state, { type, payload }) => {
  let newState = { ...state };
  switch (type) {
    case "UPDATE_STATE":
      payload.forEach((i) => {
        newState[i.key] = i.val;
      });
      return newState;
    default:
      return newState;
  }
};

/**
 *
 * @param {object} props
 *
 * 本次步驟會影響的global state
 * 1-1
 * selectedBranch
 *
 * 1-2
 * queueNumber
 * queueCode
 * currentStep (1 + 1)
 *
 */

function OrderStep_1(props) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const [state, dispatch] = useReducer(reducer, {
    useQRCode: false, // 是否使用QRCode掃描
    selectedTab: null,
    queueNumber: "",
    queueCode: "",
    branchList: [],
  });

  const nextInput = useRef(null);
  function handleFocus() {
    nextInput.current.focus();
  }

  const clickBtn = useRef(null);
  function handleClick() {
    clickBtn.current.click();
  }

  // tabs的選項
  const verifyItems = [
    {
      title: <FormattedMessage id="pages.takeOrder.step1.tabs.code" />,
      info: "code",
    },
    {
      title: <FormattedMessage id="pages.takeOrder.step1.tabs.qr" />,
      info: "qr",
    },
  ];
  // 是否使用qrcode掃描過
  const isScan = useRef(true);

  // 取得所有分店
  async function apiAllStore(langId) {
    try {
      let res = await getAllStore(langId);
      const { errCode, branch } = res.data;
      if (errCode === 200) {
        let newList = branch.map((e) => ({
          branchName: e.name,
          branchCode: e.id,
          openTime: e.openTime,
          closeTime: e.closeTime,
        }));
        console.log(newList);
        dispatch({
          type: "UPDATE_STATE",
          payload: [{ key: "branchList", val: newList }],
        });
      } else {
        dispatchGlobal({
          type: "UPDATE",
          payload: [{ key: "errCode", val: errCode }],
        });
        props.history.push("/error");
      }
    } catch (err) {
      console.error("AllStore error.");
      dispatchGlobal({
        type: "UPDATE",
        payload: [{ key: "errCode", val: 404 }],
      });
      props.history.push("/error");
    }
  }
  // 驗證排隊號碼 & 取號驗證碼
  async function apiManualVerifyQueue(requireData) {
    const waittingAlert = AsyncModel({
      content: (
        <div className="w-100 d-flex justify-content-center">
          <ReactLoading
            type="spokes"
            color="#ccc"
            height="100px"
            width="100px"
          />
        </div>
      ),
      showConfirmBtn: false,
    });
    try {
      const res = await postManualVerifyQueue(requireData);
      const { errCode } = res.data;
      AsyncModelClose();
      // 驗證通過
      if (res) {
        let {
          verify,
          childCount,
          adultsCount,
          languageID,
          countryID,
          countryName,
          storeID,
          storeName,
          orderCode,
          createAt,
          posStatus,
          posCode,
          tableNo,
          mainOrderCode,
        } = res.data.response;
        switch (errCode) {
          case 200:
            if (orderCode !== null) {
              if (posStatus) {
                dispatchGlobal({
                  type: "UPDATE",
                  payload: [
                    // 模式選擇
                    { key: "ordermode", val: "addorder" },
                    // 在這裡判斷 回傳的 countryID 需要遷換成哪種語言
                    { key: "langType", val: langCodeToString(languageID) },
                    {
                      key: "customer",
                      val: {
                        ...globalState.customer,
                        currentStep: "3",
                        orderInfo: {
                          ...globalState.customer.orderInfo,
                          country: countryID,
                          posCode: posCode,
                          tableNo: tableNo ? tableNo : "",
                          mainOrderCode: mainOrderCode,
                          countryName: countryName,
                          queueNumber: requireData.queueNumber,
                          queueCode: requireData.queueCode,
                          numberOfAdult: adultsCount,
                          numberOfChild: childCount,
                          tempOrderCode: "",
                          tempOrderGroupID: "",
                          tempOrderID: "",
                          //orderTime: moment().format("YYYY/MM/DD HH:mm:ss"),
                          selectedBranch: {
                            branchCode: storeID,
                            branchName: storeName,
                          },
                        },
                      },
                    },
                  ],
                });
              } else {
                props.history.push(
                  `/showOrderDetail?orderCode=${orderCode}&storeID=${String(
                    storeID
                  )}&createAt=${createAt}`
                );
              }
            } else {
              dispatchGlobal({
                type: "UPDATE",
                payload: [
                  // 模式選擇
                  { key: "ordermode", val: "order" },
                  // 在這裡判斷 回傳的 countryID 需要遷換成哪種語言
                  { key: "langType", val: langCodeToString(languageID) },
                  {
                    key: "customer",
                    val: {
                      ...globalState.customer,
                      currentStep: "2",
                      orderInfo: {
                        ...globalState.customer.orderInfo,
                        tableNo: tableNo ? tableNo : "",
                        country: countryID,
                        countryName: countryName,
                        queueNumber: requireData.queueNumber,
                        queueCode: requireData.queueCode,
                        numberOfAdult: adultsCount,
                        numberOfChild: childCount,
                        tempOrderCode: "",
                        tempOrderGroupID: "",
                        tempOrderID: "",
                        //orderTime: moment().format("YYYY/MM/DD HH:mm:ss"),
                        selectedBranch: {
                          branchCode: storeID,
                          branchName: storeName,
                        },
                      },
                    },
                  },
                ],
              });
            }
            break;
          case 420:
          case 4201:
            props.history.push(
              `/showOrderDetail?orderCode=${orderCode}&storeID=${String(
                storeID
              )}&createAt=${createAt}`
            );
            break;
          default:
            dispatchGlobal({
              type: "UPDATE",
              payload: [{ key: "errMsg", val: res.data.errCode }],
            });
            props.history.push("/error");
            break;
        }
      } else {
        dispatchGlobal({
          type: "UPDATE",
          payload: [{ key: "errMsg", val: res.data.errCode }],
        });
        props.history.push("/error");
      }
    } catch (err) {
      AsyncModelClose();
      console.error("LangOption error.");
      dispatchGlobal({
        type: "UPDATE",
        payload: [{ key: "errMsg", val: 405 }],
      });
      props.history.push("/error");
    }
  }
  // 驗證來店資訊
  async function apiVerifyQRCode(par) {
    try {
      const res = await postQRCodeVerifyQueue({
        queueNumber: par.queueNumber,
        queueCode: par.queueCode,
        storeID: par.storeID,
      });
      const { errCode } = res.data;
      if (res && (errCode == 200 || errCode == 420 || errCode == 4201)) {
        return res;
      } else {
        dispatchGlobal({
          type: "UPDATE",
          payload: [{ key: "errMsg", val: errCode }],
        });
        props.history.push("/error");
      }
    } catch (err) {
      console.error("QRCodeVerifyQueue error.");
      dispatchGlobal({
        type: "UPDATE",
        payload: [{ key: "errMsg", val: 405 }],
      });
      props.history.push("/error");
    }
  }
  // call api
  useEffect(() => {
    const langCode = langStringToCode(globalState.langType);
    apiAllStore(langCode);
  }, [globalState.langType]);

  // 選擇分店
  const showBranchOption = useMemo(() => {
    // 已選過分店 => 隱藏
    if (
      globalState.customer.orderInfo.selectedBranch || // 已選擇分店 => 隱藏
      state.useQRCode // QRcode 模式開啟時 => 隱藏
    )
      return null;
    return (
      <PerfectScrollbar className="col p-0">
        <div className="w-100 h-100 clearfix">
          {state.branchList.map((i, index) => (
            <CusButton
              key={index}
              disabled={(() => {
                const now = moment(new Date(), "HH:mm");
                const open = moment(i.openTime, "HH:mm");
                const close = moment(i.closeTime, "HH:mm");
                return !(now.isAfter(open) && now.isBefore(close));
              })()}
              className="Pages__branch p-3 store"
              onClick={() => {
                dispatchGlobal({
                  type: "UPDATE",
                  payload: [
                    {
                      key: "customer",
                      val: {
                        ...globalState.customer,
                        orderInfo: {
                          ...globalState.customer.orderInfo,
                          selectedBranch: i,
                        },
                      },
                    },
                  ],
                });
              }}
              children={i.branchName}
            />
          ))}
        </div>
      </PerfectScrollbar>
    );
  }, [
    globalState.customer.orderInfo.selectedBranch,
    globalState.device,
    state.useQRCode,
    state.branchList,
  ]);
  // QRcode掃描
  const showQRCode = useMemo(() => {
    if (
      !state.useQRCode || // 沒有選擇QRCode功能
      // globalState.device === 'pc' || // 非行動裝置
      (isIOS && !isSafari) || // ios系統但瀏覽器非safari
      (isAndroid && !(isChrome || isFirefox)) // android系統但瀏覽器非 chrome || firefox
    )
      return null;
    return (
      <div className="Pages__QRCode">
        <QrReader
          delay={600}
          onError={(err) => {
            console.error(err);
          }}
          onScan={async (data) => {
            let par; //是否有合法的參數
            if (!data) return (isScan.current = true);
            if (data && isScan.current) {
              par = qs.parse(data.split("?")[1]);
              isScan.current = false;
              const waittingAlert = AsyncModel({
                content: (
                  <div className="w-100 d-flex justify-content-center">
                    <ReactLoading
                      type="spokes"
                      color="#ccc"
                      height="100px"
                      width="100px"
                    />
                  </div>
                ),
                showConfirmBtn: false,
              });
            }
            if (par) {
              const qrcode = await apiVerifyQRCode(par);
              AsyncModelClose();
              if (qrcode) {
                const {
                  verify,
                  childCount,
                  adultsCount,
                  countryID,
                  countryName,
                  storeID,
                  storeName,
                  languageID,
                  createAt,
                  posStatus,
                  posCode,
                  tableNo,
                  mainOrderCode,
                  orderCode,
                } = qrcode.data.response;
                const { errCode } = qrcode.data;
                switch (errCode) {
                  case 200:
                    if (orderCode !== null) {
                      if (posStatus) {
                        dispatchGlobal({
                          type: "UPDATE",
                          payload: [
                            // 模式選擇
                            { key: "ordermode", val: "addorder" },
                            // 在這裡判斷 回傳的 countryID 需要遷換成哪種語言
                            {
                              key: "langType",
                              val: langCodeToString(languageID),
                            },
                            {
                              key: "customer",
                              val: {
                                ...globalState.customer,
                                currentStep: "3",
                                orderInfo: {
                                  ...globalState.customer.orderInfo,
                                  country: countryID,
                                  posCode: posCode,
                                  tableNo: tableNo ? tableNo : "",
                                  mainOrderCode: mainOrderCode,
                                  countryName: countryName,
                                  queueNumber: par.queueNumber,
                                  queueCode: par.queueCode,
                                  numberOfAdult: adultsCount,
                                  numberOfChild: childCount,
                                  tempOrderCode: "",
                                  tempOrderGroupID: "",
                                  tempOrderID: "",
                                  //orderTime: moment().format(
                                  //  "YYYY/MM/DD HH:mm:ss"
                                  //),
                                  selectedBranch: {
                                    branchCode: storeID,
                                    branchName: storeName,
                                  },
                                },
                              },
                            },
                          ],
                        });
                      } else {
                        props.history.push(
                          `/showOrderDetail?orderCode=${orderCode}&storeID=${String(
                            storeID
                          )}&createAt=${createAt}`
                        );
                      }
                    } else {
                      dispatchGlobal({
                        type: "UPDATE",
                        payload: [
                          // 模式選擇
                          { key: "ordermode", val: "order" },
                          // 在這裡判斷 回傳的 countryID 需要遷換成哪種語言
                          {
                            key: "langType",
                            val: langCodeToString(languageID),
                          },
                          {
                            key: "customer",
                            val: {
                              ...globalState.customer,
                              currentStep: "2",
                              orderInfo: {
                                ...globalState.customer.orderInfo,
                                tableNo: tableNo ? tableNo : "",
                                country: countryID,
                                countryName: countryName,
                                queueNumber: par.queueNumber,
                                queueCode: par.queueCode,
                                numberOfAdult: adultsCount,
                                numberOfChild: childCount,
                                tempOrderCode: "",
                                tempOrderGroupID: "",
                                tempOrderID: "",
                                orderTime: moment().format(
                                  "YYYY/MM/DD HH:mm:ss"
                                ),
                                selectedBranch: {
                                  branchCode: storeID,
                                  branchName: storeName,
                                },
                              },
                            },
                          },
                        ],
                      });
                    }
                    break;
                  case 420:
                  case 4201:
                    props.history.push(
                      `/showOrderDetail?orderCode=${orderCode}&storeID=${String(
                        storeID
                      )}&createAt=${createAt}`
                    );
                    break;
                  default:
                    dispatchGlobal({
                      type: "UPDATE",
                      payload: [{ key: "errMsg", val: errCode }],
                    });
                    props.history.push("/error");
                    break;
                }
                /*
                dispatchGlobal({
                  type: 'UPDATE',
                  payload: [
                    // 在這裡判斷 回傳的 countryID 需要遷換成哪種語言
                    { key: 'langType', val: langCodeToString(languageID) },
                    {
                      key: 'customer',
                      val: {
                        ...globalState.customer,
                        isReady: true,
                        currentStep: '2',
                        mealDetail: '',
                        mealOrderDetail: [],
                        orderInfo: {
                          ...globalState.customer.orderInfo,
                          country: countryID,
                          countryName: countryName,
                          queueNumber: par.queueNumber,
                          queueCode: par.queueCode,
                          numberOfAdult: adultsCount,
                          numberOfChild: childCount,
                          orderTime: moment().format('YYYY/MM/DD hh:mm:ss'),
                          selectedBranch: {
                            branchCode: storeID,
                            branchName: storeName
                          }
                        },
                        // orderDetail: {
                        //   totalMealQuantity: 0,
                        //   dineInTotalPrice: 0,
                        //   dineInSpecPrice: 0,
                        //   takeoutInTotalPrice: 0,
                        //   takeoutInSpecPrice: 0
                        // }
                      }
                    }
                  ]
                });
                */
              }
            } else {
              dispatchGlobal({
                type: "UPDATE",
                payload: [{ key: "errMsg", val: 419 }],
              });
              props.history.push("/error");
            }
          }}
          style={{ width: "100%" }}
        />
      </div>
    );
  }, [state.useQRCode, globalState.device]);
  // 輸入排隊號碼 & 取號驗證碼
  const showInputFrom = useMemo(() => {
    let pcStyle = globalState.device === "pc";
    if (
      !globalState.customer.orderInfo.selectedBranch || // 未選擇分店 => 隱藏
      state.useQRCode // QRcode 模式開啟時 => 隱藏
    )
      return null;
    return (
      <div className="d-flex col flex-column justify-content-center align-items-center p-0">
        <div style={{ minWidth: pcStyle ? "500px" : "100%" }}>
          {/* 排隊號碼 */}
          <div className="mb-4 mb-sm-5 w-100">
            <FormattedMessage
              type="tel"
              id="pages.takeOrder.step1.queueNumberInputPlaceholder"
              children={(msg) => {
                return (
                  <CusInput
                    type="tel"
                    className={cls("w-100")}
                    maxLength={4}
                    label={
                      <FormattedMessage id="pages.takeOrder.step1.queueNumberInputTitle" />
                    }
                    value={state.queueNumber}
                    onKeyPress={(ev) => {
                      if (ev.key === "Enter") {
                        handleFocus();
                      }
                    }}
                    placeholder={msg}
                    onChange={(event) => {
                      let val = event.target.value;
                      dispatch({
                        type: "UPDATE_STATE",
                        payload: [{ key: "queueNumber", val: val }],
                      });
                    }}
                  />
                );
              }}
            />
          </div>
          {/* 取號驗證碼 */}
          <div className="mb-4 mb-sm-5 w-100">
            <FormattedMessage
              id="pages.takeOrder.step1.queueCodeInputPlaceholder"
              children={(msg) => {
                return (
                  <CusInput
                    type="tel"
                    // pattern="[0-9]*"
                    className={cls("w-100")}
                    maxLength={5}
                    label={
                      <FormattedMessage id="pages.takeOrder.step1.queueCodeInputTitle" />
                    }
                    innerRef={nextInput}
                    value={state.queueCode}
                    placeholder={msg}
                    onKeyPress={(ev) => {
                      if (ev.key === "Enter") {
                        handleClick();
                      }
                    }}
                    onChange={(event) => {
                      let val = event.target.value;
                      dispatch({
                        type: "UPDATE_STATE",
                        payload: [{ key: "queueCode", val: val }],
                      });
                    }}
                  />
                );
              }}
            />
          </div>
          <div className="mt-3 bgColorBrown-10 text-black p-3 ">
            <FormattedMessage id="pages.takeOrder.step1.allergen" />
          </div>
          {/* button */}
          <div className="mt-3 mb-3 mt-sm-5 mb-sm-5 w-100 d-flex">
            <CusButton.White
              className="mt-2 mb-2 mr-3 col p-3"
              children={
                <FormattedMessage id="pages.takeOrder.step1.buttonBack" />
              }
              onClick={() => {
                dispatchGlobal({
                  type: "UPDATE",
                  payload: [
                    {
                      key: "customer",
                      val: {
                        ...globalState.customer,
                        orderInfo: {
                          ...globalState.customer.orderInfo,
                          selectedBranch: "",
                          queueNumber: "",
                          queueCode: "",
                          numberOfAdult: "",
                          numberOfChild: "",
                          //orderTime: "",
                        },
                      },
                    },
                  ],
                });
              }}
            />
            <CusButton.Red
              className="mt-2 mb-2 ml-3 col p-3"
              disabled={!state.queueNumber || !state.queueCode}
              children={
                <FormattedMessage id="pages.takeOrder.step1.buttonConfirm" />
              }
              innerRef={clickBtn}
              onClick={async () => {
                let { branchCode } =
                  globalState.customer.orderInfo.selectedBranch;
                apiManualVerifyQueue({
                  queueNumber: state.queueNumber,
                  queueCode: state.queueCode,
                  storeID: branchCode,
                  languageID: langStringToCode(globalState.langType),
                });
              }}
            />
          </div>
        </div>
      </div>
    );
  }, [
    globalState.customer.orderInfo.selectedBranch,
    globalState.device,
    state.useQRCode,
    state.queueNumber,
    state.queueCode,
  ]);
  return (
    <>
      {/* 選擇驗證方式 tabs */}
      {(() => {
        // 禁止顯示 tabs
        if (
          // globalState.device === 'pc' || // 非行動裝置   // 消費者先不判斷寬度
          (isIOS && !isSafari) || // ios系統但瀏覽器非safari
          (isAndroid && !(isChrome || isFirefox)) // android系統但瀏覽器非 chrome || firefox
        ){
          return null;
        }

        return (
          <Tool_tabs
            items={verifyItems}
            selected={state.selectedTab || verifyItems[0]}
            onChangeItems={(selectedTab) => {
              let useQRCode = selectedTab.info === "qr";
              dispatch({
                type: "UPDATE_STATE",
                payload: [
                  { key: "selectedTab", val: selectedTab },
                  { key: "useQRCode", val: useQRCode },
                ],
              });
            }}
          />
        );
      })()}
      {/* QR code */}
      {globalState.device !== "pc" && !state.useQRCode ? (
        <div className="Pages__action d-flex justify-content-center align-items-center pt-3 pb-3 mt-sm-3 mb-sm-3">
          {globalState.customer.orderInfo.selectedBranch ? (
            <Tool_storeName
              storeId={globalState.customer.orderInfo.selectedBranch.branchCode}
            />
          ) : (
            <FormattedMessage id="pages.takeOrder.step1.defaultSelectedBranch" />
          )}
        </div>
      ) : null}
      <div className="d-flex col flex-column mt-3 mb-3 p-0">
        <>
          {showBranchOption}
          {showQRCode}
          {showInputFrom}
        </>
      </div>
    </>
  );
}

export default withRouter(OrderStep_1);
